import { render, staticRenderFns } from "./page_yw.vue?vue&type=template&id=183322fc&"
import script from "./page_yw.vue?vue&type=script&lang=js&"
export * from "./page_yw.vue?vue&type=script&lang=js&"
import style0 from "./page_yw.vue?vue&type=style&index=0&id=183322fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports